//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.ShipDesign.js";
import "../no/Builder.js";
import "../no/SelectBody.js";
import "../Features/Features.ShipDesign.RoomAttributeListBuilder.js";
import "../no/SelectBodyList.js";
import "../no/Section.js";
import "../Features/Features.ShipDesign.ShipNamesBuilder.js";
import "../Features/Features.ShipDesign.RoomThicknessItemBuilderList.js";
import "../no/Expression.js";
import "../no/Expression.js";
import "../no/Section.js";
import "../no/SelectObject.js";
import "../no/SelectObjectList.js";
import "../no/Features.js";
import "../no/ObjectList.js";
let d=[[[1,"AdoptionBody",0,"SelectBody",0],[1,"AttributeList",0,"Features.ShipDesign.RoomAttributeListBuilder",0],[0,"CalculateRoomAttributes",1,0],[0,"CreateCogPoints",1,0],[0,"CreateRoomWithReferenceComponent",1,0],[0,"CreateRoomWithWall",1,0],[1,"Deck",0,"SelectBodyList",0],[0,"DistanceTolerance",1,0],[0,"RoomColor",1,0],[1,"Section",0,"Section",0],[1,"ShipNames",0,"Features.ShipDesign.ShipNamesBuilder",0],[1,"ThicknessList",0,"Features.ShipDesign.RoomThicknessItemBuilderList",0],[0,"Type",1,0],[1,"WallThickness",0,"Expression",0]],[[["bUpdateRoomAreaAndVolume"],"EvaluateAttributes",{},1,0],[[],"UpdateTypeForAttributeListBuilder",{},0,0],[[],"AdoptChanged",{},0,0],[["nBodies","createdRoomBodies"],"GetCreatedRoomBodies",{},0,0],[["builderTo"],"CloneSectionBuilder",{},1,0],[["needDeleteOldSettion","section"],"UpdateSection",{},2,0],[["section"],"UpdateSectionCurves",{},1,0],[["newBuilder"],"AddNewRoomBuilder",{},1,0],[["roomBuilder"],"RemoveRoomBuilder",{},1,0],[["roomID"],"UpdateRoomID",{},1,0],[["bUpdateRoomAreaAndVolume"],"ResetAttributes",{},1,0],[["spaceType"],"UpdateSpaceType",{},1,0],[[],"ClearDeckBodies",{},0,0],[["deckBody"],"AddDeckBody",{},1,0]],[]];
SPLM.Features.ShipDesign.RoomBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.ShipDesign.RoomBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.ShipDesign.RoomBuilder.Types = Object.freeze({
    "Create" : "Create", "Adopt" : "Adopt"});

export default SPLM;